"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RangeSlider = void 0;
var React = _interopRequireWildcard(require("react"));
var _color = require("../../styles/variables/_color");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _Button = require("../Button");
var _Input = require("../Input");
var _Text = require("../Text");
var _RangeSliderModule = _interopRequireDefault(require("./RangeSlider.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const RangeSlider = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    classNames,
    disabled,
    min = 0,
    max = 100,
    step = 1,
    value = min,
    onChange,
    showTicks,
    iconLeftName = 'minus',
    btnLeftSize = _Button.BUTTON_SIZE.small,
    iconRightName = 'plus',
    btnRightSize = _Button.BUTTON_SIZE.small,
    hideLeftBtn,
    hideRightBtn,
    ariaLabel = 'Slider',
    showRange,
    hideValueInput,
    ...restInputProps
  } = _ref;
  const progress = (value - min) / (max - min) * 100;
  const btnLeftDisabled = disabled || value <= min;
  const btnRightDisabled = disabled || value >= max;
  const progressColor = disabled ? _color.colorTextDisabled : _color.colorFillPrimary;
  const handleInputChange = e => {
    let inputValue = parseFloat(e.currentTarget.value);

    // Validate and adjust the value
    if (isNaN(inputValue) || inputValue < min) {
      inputValue = min;
    } else if (inputValue > max) {
      inputValue = max;
    } else if (step > 0) {
      const nearestStep = Math.round(inputValue / step) * step;
      inputValue = Math.round(nearestStep * 100) / 100; // Adjust to nearest valid step
    }

    onChange?.(inputValue);
  };
  const handleChange = e => {
    emitRoundedValue(e.currentTarget.value);
  };
  const emitRoundedValue = value => {
    const newValue = parseFloat(value);
    const roundedValue = Math.round(newValue * 100) / 100; // Rounds to two decimal places
    onChange?.(roundedValue);
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    "data-testid": "RangeSlider",
    className: (0, _classify.default)(_RangeSliderModule.default.wrapper, {
      [_RangeSliderModule.default.disabled]: disabled
    }, classNames?.wrapper)
  }, !hideLeftBtn && !showRange && /*#__PURE__*/React.createElement(_Button.Button, {
    type: "ghost",
    iconLeftName: iconLeftName,
    size: btnLeftSize,
    ariaLabel: "Decrease Value",
    disabled: btnLeftDisabled,
    onClick: () => emitRoundedValue(value - step)
  }), showRange && /*#__PURE__*/React.createElement(_Text.BodySmall, {
    className: _RangeSliderModule.default.rangeText,
    color: disabled ? 'disabled' : 'primary'
  }, min), /*#__PURE__*/React.createElement("div", {
    className: _RangeSliderModule.default.sliderContainer
  }, /*#__PURE__*/React.createElement("input", _extends({}, restInputProps, {
    type: "range",
    min: min,
    max: max,
    step: step,
    value: value,
    onChange: handleChange,
    className: _RangeSliderModule.default.slider,
    list: showTicks ? 'ticks' : undefined,
    disabled: disabled,
    "aria-label": ariaLabel,
    style: {
      background: `linear-gradient(to right, ${progressColor} ${progress}%, ${_color.colorGrayLightest} ${progress}%)`
    }
  })), showTicks && step > 0 && /*#__PURE__*/React.createElement("datalist", {
    id: "ticks",
    className: _RangeSliderModule.default.sliderTicks
  }, Array.from({
    length: (max - min) / step + 1
  }, (_, index) => /*#__PURE__*/React.createElement("option", {
    key: index,
    value: min + index * step,
    className: (0, _classify.default)({
      [_RangeSliderModule.default.disabled]: disabled
    })
  })))), showRange && /*#__PURE__*/React.createElement(_Text.BodySmall, {
    className: _RangeSliderModule.default.rangeText,
    color: disabled ? 'disabled' : 'primary'
  }, max), !hideRightBtn && !showRange && /*#__PURE__*/React.createElement(_Button.Button, {
    type: "ghost",
    iconRightName: iconRightName,
    size: btnRightSize,
    ariaLabel: "Increase Value",
    disabled: btnRightDisabled,
    onClick: () => emitRoundedValue(value + step)
  }), !hideValueInput && /*#__PURE__*/React.createElement(_Input.Input, {
    size: "small",
    type: "number",
    value: String(value),
    classNames: {
      wrapper: _RangeSliderModule.default.valueInputWrapper
    },
    disabled: disabled,
    onChange: handleInputChange,
    disallowExponents: true,
    hideNumberSpinner: true
  }));
});
exports.RangeSlider = RangeSlider;